import React, { useEffect, useState } from "react";
import { cdnImg } from "../../Utils/cdnImage";
import Layout from "../Layout";
import AccountLayout from "./AccountLayout";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import moment from "moment";
import NoData from "../../component/NoData";
import { Form } from "react-bootstrap";
const Refrel = () => {
  const { t } = useTranslation();
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const today = moment().format("YYYY-MM-DD");
  const monthStart = moment().startOf("month").format("YYYY-MM-DD");

  const [filter, setFilter] = useState({
    page: 1,
    limit: 100,
    fromPeriod: monthStart,
    toPeriod: today,
  });

  const [summary, setSummary] = useState({
    totalBonusEarn: 0,
    totalPlayerPL: 0,
  });

  const [matchData, setMatchData] = useState([]);

  const getMatchData = async () => {
    try {
      let requestFilter = { ...filter };

      if (filter.filterByDay) {
        if (filter.filterByDay === "today") {
          requestFilter.fromPeriod = today;
          requestFilter.toPeriod = today;
        }

        if (filter.filterByDay === "yesterday") {
          const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
          requestFilter.fromPeriod = yesterday;
          requestFilter.toPeriod = yesterday;
        }
      }

      const { status, data } = await apiGet(
        apiPath.referralReport,
        requestFilter,
      );
      if (data?.success == true) {
        const results = data.results || [];

        setMatchData(results);

        const totals = results.reduce(
          (acc, item) => {
            acc.totalBonusEarn += Number(item?.earnd || 0);
            acc.totalPlayerPL += Number(item?.playerPL || 0);
            return acc;
          },
          { totalBonusEarn: 0, totalPlayerPL: 0 },
        );

        setSummary(totals);
      }
    } catch (error) {
      console.error("Referral report error:", error);
    }
  };

  useEffect(() => {
    getMatchData();
  }, [filter]);
  const navigate = useNavigate();
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: t("ReferFriendTitle"),
          text: t("ReferFriendText"),
          url: `https://bajifair.live/register?referral_code=${profileData?.referalCode || profileData?.username}`,
        });
      } catch (error) {}
    } else {
      alert(t("ShareNotSupported"));
    }
  };
  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(profileData?.referalCode || profileData?.username)
      .then(() => {
        toast.success(t("CopiedClipboard"));
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  return (
    <AccountLayout title={t("Referral")}>
      <ng-component
        _nghost-serverapp-c218240816=""
        class="ng-tns-c218240816-13 ng-star-inserted"
        style={{}}
      >
        <div
          _ngcontent-serverapp-c218240816=""
          className="referral-entry ng-tns-c218240816-13 ng-trigger ng-trigger-tabPageTriggerAni"
        >
          <router-outlet
            _ngcontent-serverapp-c218240816=""
            class="ng-tns-c218240816-13"
          />
          <ng-component
            _nghost-serverapp-c1696643091=""
            class="ng-tns-c1696643091-17 ng-star-inserted"
            style={{}}
          >
            <div
              _ngcontent-serverapp-c1696643091=""
              className="referral-information inner-box ng-tns-c1696643091-17 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
              style={{}}
            >
              <div
                _ngcontent-serverapp-c1696643091=""
                className="referral-information__head ng-tns-c1696643091-17"
              >
                <div
                  _ngcontent-serverapp-c1696643091=""
                  className="referral-information__banner ng-tns-c1696643091-17"
                >
                  <img
                    _ngcontent-serverapp-c1696643091=""
                    alt="referral-banner"
                    className="ng-tns-c1696643091-17 ng-star-inserted"
                    loading="eager"
                    src={cdnImg("/assets/images/referral-program-banner.png")}
                    style={{}}
                  />
                </div>
              </div>
              <div
                _ngcontent-serverapp-c1696643091=""
                className="recommend-friends-box ng-tns-c1696643091-17"
              >
                <div
                  _ngcontent-serverapp-c1696643091=""
                  className="referral-information__panel referral-information-panel referral-terms-panel ng-tns-c1696643091-17"
                />
                <div
                  _ngcontent-serverapp-c1696643091=""
                  className="code-box referral-information__panel referral-information-panel referral-code-panel ng-tns-c1696643091-17"
                >
                  <p
                    style={{
                      color: "white",
                      textAlign: "center",
                      fontSize: "13px",
                    }}
                  >
                    The best referral program here! Every time your referred
                    friend makes a loss, you will earn a weekly 3% commission.
                    This commission will be added to the main balance every
                    Monday on Monday, ensuring regular rewards from your
                    referrals!.{" "}
                  </p>
                  <div
                    _ngcontent-serverapp-c1696643091=""
                    className="referral-code-panel__code code-panel-area ng-tns-c1696643091-17"
                  >
                    <span
                      style={{
                        color: "white",
                        border: "2px dashed white",
                        padding: "5px 8px",
                        borderRadius: "8px",
                      }}
                      _ngcontent-serverapp-c1696643091=""
                      className="code-panel-area__code ng-tns-c1696643091-17"
                    >
                      {profileData?.referalCode || profileData?.username}
                    </span>
                    <span
                      onClick={() => copyToClipboard()}
                      _ngcontent-serverapp-c1696643091=""
                      className="code-panel-area__icon ng-tns-c1696643091-17"
                      style={{
                        maskImage: 'url("/assets/images/icon-copy.svg")',
                      }}
                    />
                  </div>
                  <p
                    style={{
                      color: "white",
                      textAlign: "center",
                      fontSize: "13px",
                      marginBottom: "8px",
                    }}
                  >
                    সেরা রেফারেল প্রোগ্রাম এখানে! আপনার রেফার করা বন্ধু প্রতিবার
                    ক্ষতি করলে আপনি সাপ্তাহিক 3% কমিশন উপার্জন করবেন। এই কমিশন
                    প্রতি সপ্তাহের সোমবার মূল ব্যালেন্সে যোগ করা হবে, যেটি আপনার
                    রেফারেল থেকে নিয়মিত পুরস্কার নিশ্চিত করবে!{" "}
                  </p>
                  <div
                    _ngcontent-serverapp-c1696643091=""
                    className="referral-code-panel__btn-wrap ng-tns-c1696643091-17"
                  >
                    <div
                      _ngcontent-serverapp-c1696643091=""
                      className="referral-code-panel__btn referral-code-panel__btn-link ng-tns-c1696643091-17"
                    >
                      Ongoing pnl:
                      <span
                        className={
                          summary?.totalPlayerPL >= 0
                            ? "text-green"
                            : "text-red"
                        }
                        style={{ marginLeft: "5px" }}
                      >
                        {Math.abs(summary?.totalPlayerPL ?? 0).toFixed(2) ||
                          0.0}
                      </span>
                    </div>
                    <div
                      onClick={() => handleShare()}
                      _ngcontent-serverapp-c1696643091=""
                      className="referral-code-panel__btn ng-tns-c1696643091-17 ng-star-inserted"
                      style={{}}
                    >
                      Ongoing commission:{" "}
                      <span style={{ marginLeft: "5px" }}>
                        {Math.abs(
                          ((3 / 100) * summary?.totalPlayerPL)?.toFixed(2),
                        ) || 0.0}
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",

                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  <input
                    className="small_form_control"
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        fromPeriod: e.target.value,
                      })
                    }
                    style={{
                      background: "#ffb80c",
                      border: "none",
                      padding: "5px",
                      borderRadius: "5px",
                      width: "40%",
                    }}
                    max={new Date().toISOString().split("T")[0]}
                    value={filter.fromPeriod}
                    type="date"
                  />
                  <input
                    className="small_form_control"
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        toPeriod: e.target.value,
                      })
                    }
                    style={{
                      background: "#ffb80c",
                      border: "none",
                      padding: "5px",
                      borderRadius: "5px",
                      width: "40%",
                    }}
                    min={
                      filter?.fromPeriod
                        ? new Date(filter?.fromPeriod)
                            .toISOString()
                            .split("T")[0]
                        : new Date()
                    }
                    max={new Date().toISOString().split("T")[0]}
                    value={filter.toPeriod}
                    type="date"
                  />
                </div>

                <ul
                style={{background:'#043b3d',padding:"10px 0",marginTop:'10px'}}
                  _ngcontent-serverapp-c221247831
                  className="cricket-list-content ng-tns-c221247831-105"
                >
                  {matchData?.length > 0 ? (
                    matchData?.map((res) => {
                      return (
                        <li
                          style={{ color: "white" }}
                          _ngcontent-serverapp-c3238644402
                          className={`accordion-wrap ng-tns-c3238644402-106 ng-star-inserted`}
                        >
                          <div
                            _ngcontent-serverapp-c3238644402
                            // style={{ padding: "0" }}
                            className={`accordion-header ng-tns-c3238644402-106 ng-star-inserted`}
                          >
                            <div
                              style={{ display: "block" }}
                              _ngcontent-serverapp-c3238644402
                              className="main-info ng-tns-c3238644402-106"
                            >
                              <div
                                _ngcontent-serverapp-c3238644402
                                className="title ng-tns-c3238644402-106"
                              >
                                <span
                                  _ngcontent-serverapp-c3238644402
                                  className="category-type ng-tns-c3238644402-106"
                                >
                                  {res.username}
                                </span>
                              </div>
                            </div>
                            <div
                              _ngcontent-serverapp-c3238644402
                              className="betting-info ng-tns-c3238644402-106"
                            >
                              <div
                                _ngcontent-serverapp-c3238644402
                                className="avg-odds ng-tns-c3238644402-106"
                              >
                                <svg
                                  _ngcontent-serverapp-c3238644402
                                  className="item-icon ng-tns-c3238644402-106"
                                >
                                  <circle
                                    _ngcontent-serverapp-c3238644402
                                    cx={9}
                                    cy={9}
                                    r={9}
                                    className="circle ng-tns-c3238644402-106"
                                  />
                                  <use
                                    _ngcontent-serverapp-c3238644402
                                    href={"/assets/Other/icon-odds.svg"}
                                    className="icon ng-tns-c3238644402-106"
                                  />
                                </svg>
                                <strong _ngcontent-serverapp-c3238644402>
                                  {Math.abs(res.earnd?.toFixed(2)) || 0}
                                </strong>
                                <span
                                  _ngcontent-serverapp-c3238644402
                                  className="ng-tns-c3238644402-106"
                                >
                                  Bonus Earned
                                </span>
                              </div>

                              <div
                                _ngcontent-serverapp-c3238644402
                                className="avg-odds ng-tns-c3238644402-106"
                              >
                                <svg
                                  _ngcontent-serverapp-c3238644402
                                  className="item-icon ng-tns-c3238644402-106"
                                >
                                  <circle
                                    _ngcontent-serverapp-c3238644402
                                    cx={9}
                                    cy={9}
                                    r={9}
                                    className="circle ng-tns-c3238644402-106"
                                  />
                                  <use
                                    _ngcontent-serverapp-c3238644402
                                    href={"/assets/Other/icon-odds.svg"}
                                    className="icon ng-tns-c3238644402-106"
                                  />
                                </svg>
                                <strong _ngcontent-serverapp-c3238644402>
                                  {Math.sign(res.playerPL) == 1 ? (
                                    Math.abs(res.playerPL) != 0 ? (
                                      <span
                                        style={{ fontSize: "unset" }}
                                        className="text-success"
                                      >
                                        {Math.abs(res.playerPL?.toFixed(2))}
                                      </span>
                                    ) : (
                                      0.0
                                    )
                                  ) : Math.abs(res.playerPL) != 0 ? (
                                    <span
                                      style={{ fontSize: "unset" }}
                                      className="text-danger"
                                    >
                                      {Math.abs(res.playerPL?.toFixed(2))}
                                    </span>
                                  ) : (
                                    0.0
                                  )}
                                </strong>
                                <span
                                  _ngcontent-serverapp-c3238644402
                                  className="ng-tns-c3238644402-106"
                                >
                                  P&L
                                </span>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <NoData />
                  )}
                </ul>
              </div>
            </div>
          </ng-component>
        </div>
      </ng-component>
    </AccountLayout>
  );
};

export default Refrel;
